import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { useMainStore } from '@/store/mainStore';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('../views/MyCart.vue')
  },
  {
    path: '/POcheckout',
    name: 'POCheckout',
    component: () => import('../views/CheckOut.vue')
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import('../views/ItemCheckOut.vue')
  },
  {
    path: '/approval',
    name: 'Approval',
    component: () => import('../views/ApprovalAdmin.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/catalogue',
    name: 'Catalogue',
    meta: {
      canChangeShip: true
    },
    component: () => import('../views/CatalogueView.vue')
  },
  {
    path: '/itemorder/:ID',
    name: 'ItemOrder',
    component: () => import('../views/ItemOrder.vue')
  },
  {
    path: '/myinfo',
    name: 'MyInfo',
    component: () => import('../views/MyInfo.vue')
  },
  {
    path: '/subvendors',
    name: 'SubVendors',
    component: () => import('../views/SubVendors.vue')
  },
  {
    path: '/newsubvendor',
    name: 'NewSubVendor',
    component: () => import('../views/NewSubVendor.vue')
  },
  {
    path: '/accountrequest/bill/',
    name: 'AccountRequestBill',
    component: () => import('../views/AccountRequest.vue'),
    meta: {
      mode: "bill",
      edit: false
    },
    children: [
      {
        path: "edit",
        name: "BillToEdit",
        component: () => import('../views/AccountRequest.vue'),
        props: route => ({ query: route.query.billTo }),
        meta: {
          mode: "bill",
          edit: true
        },
      }
    ]
  },
  {
    path: '/accountrequest/ship/',
    name: 'AccountRequestShip',
    component: () => import('../views/AccountRequest.vue'),
    meta: {
      mode: "ship",
      edit: false
    },
    children: [
      {
        path: "edit",
        name: "ShipToEdit",
        component: () => import('../views/AccountRequest.vue'),
        props: route => ({ query: route.query.shipTo }),
        meta: {
          mode: "ship",
          edit: true
        },
      }
    ]
  },
  {
    path: '/vatrequest',
    name: 'VATRequest',
    component: () => import('../views/VATRequest.vue')
  },
  {
    path: '/myorders',
    name: 'MyOrders',
    component: () => import('../views/MyOrders.vue')
  },
  {
    path: '/editorder',
    name: 'EditOrder',
    component: () => import('../views/EditOrder.vue')
  },
  {
    path: '/mypoorders',
    name: 'MyPOOrders',
    component: () => import('../views/MyPOOrders.vue')
  },
  {
    path: '/myreports',
    name: 'MyReports',
    component: () => import('../views/MyReports.vue')
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('../views/HelpView.vue')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('../views/SupportView.vue')
  },
  {
      path: '/supportrequests',
        name: 'SupportList',
        component: () => import('../views/SupportList.vue'),
  },

  {
    path: '/signin',
    name: 'SignIn',
    meta: {
      showNav: false,
      public: true
  },
   
    component: () => import('../views/SignIn.vue')
  }
]




const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
  history: createWebHistory(),
  routes
});
//Router navigation guards here
//If no logged in user, attempt to log in with a saved token, else redirect to the sign in page
router.beforeEach(async (to) => {
  const mainStore = useMainStore()
  if (mainStore?.isAuth == false && to.meta.public != true) {
    await mainStore.getUser();
    if (mainStore.isAuth ==  false) {
      router.push({name: 'SignIn'})
    }
    
  }
  if(mainStore.editMode == true) {
    if(to.name == 'EditOrder' || to.name == 'Checkout' || to.name == 'ItemOrder') {
      return
    }
    await mainStore.deleteEditCart();
    return;
  }
  return
  
})
export default router
